(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Demeure-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.getElementById('demeure-header-{{ section.id }}');
  if(!section) return;

  var toggle = section.querySelector('[data-mobile-toggle]');
  var close = section.querySelector('[data-mobile-close]');
  var menu = section.querySelector('[data-mobile-menu]');

  function open(){
    if(menu) menu.classList.add('dmh-open');
    document.body.style.overflow = 'hidden';
  }
  function shut(){
    if(menu) menu.classList.remove('dmh-open');
    document.body.style.overflow = '';
  }

  if(toggle) toggle.addEventListener('click', open);
  if(close) close.addEventListener('click', shut);

  // Close on escape
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') shut();
  });

  // Close when clicking a link
  if(menu){
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', shut);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demeure-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.getElementById('demeure-{{ section.id }}');
  if(!section) return;

  // Reusable carousel initializer
  function initCarousel(suffix){
    var track    = section.querySelector('[data-carousel-track'    + suffix + ']');
    var prev     = section.querySelector('[data-carousel-prev'     + suffix + ']');
    var next     = section.querySelector('[data-carousel-next'     + suffix + ']');
    var current  = section.querySelector('[data-carousel-current'  + suffix + ']');
    var totalLbl = section.querySelector('[data-carousel-total'    + suffix + ']');
    var progress = section.querySelector('[data-carousel-progress' + suffix + ']');

    if(!track || !prev || !next) return;

    var items = track.querySelectorAll('.dm-product');
    var total = items.length;

    if(totalLbl) totalLbl.textContent = '/ ' + String(total).padStart(2,'0');

    function getStep(){
      var first = items[0];
      if(!first) return 0;
      return first.getBoundingClientRect().width;
    }
    function getVisibleCount(){
      var w = window.innerWidth;
      if(w <= 780) return 1;
      if(w <= 1100) return 2;
      return 4;
    }
    function update(){
      var step = getStep();
      if(step === 0) return;
      var visible = getVisibleCount();
      var idx = Math.round(track.scrollLeft / step);
      var displayIdx = Math.min(idx + 1, total);
      if(current) current.textContent = String(displayIdx).padStart(2,'0');
      var maxScroll = track.scrollWidth - track.clientWidth;
      var pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) : 0;
      if(progress){
        var barWidth = (visible / total) * 100;
        progress.style.width = barWidth + '%';
        progress.style.transform = 'translateX(' + ((100 - barWidth) * pct) + '%)';
      }
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }
    prev.addEventListener('click', function(){ track.scrollBy({left:-getStep(), behavior:'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left:getStep(), behavior:'smooth'}); });
    track.addEventListener('scroll', function(){ requestAnimationFrame(update); });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
  }

  // Initialize both carousels
  initCarousel('');     // first: data-carousel-track, etc
  initCarousel('-2');   // second: data-carousel-track-2, etc
  initCarousel('-3');   // third: data-carousel-track-3, etc
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demure-collections-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.getElementById('demeure-collection-{{ section.id }}');
  if(!section) return;

  // ===== Close filter dropdowns when clicking outside =====
  document.addEventListener('click', function(e){
    section.querySelectorAll('.dc-filter[open]').forEach(function(d){
      if(!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // ===== Track active filters & show clear button =====
  function updateActiveCount(){
    var checked = section.querySelectorAll('input[type="checkbox"]:checked').length;
    var counter = section.querySelector('[data-active-count]');
    var clear = section.querySelector('[data-clear-filters]');
    if(counter) counter.textContent = checked > 0 ? checked + ' filters applied' : '';
    if(clear) clear.classList.toggle('dc-show', checked > 0);
  }
  section.querySelectorAll('input[type="checkbox"]').forEach(function(input){
    input.addEventListener('change', updateActiveCount);
  });
  updateActiveCount();

  // Clear all
  var clearBtn = section.querySelector('[data-clear-filters]');
  if(clearBtn){
    clearBtn.addEventListener('click', function(){
      section.querySelectorAll('input[type="checkbox"]:checked').forEach(function(c){
        c.checked = false;
      });
      updateActiveCount();
    });
  }

  // ===== Sort: change url param =====
  var sortSelect = section.querySelector('.dc-sort');
  if(sortSelect){
    var url = new URL(window.location.href);
    var current = url.searchParams.get('sort_by');
    if(current) sortSelect.value = current;
    sortSelect.addEventListener('change', function(){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSelect.value);
      window.location.href = u.toString();
    });
  }

  // ===== Load more (demo only — for real Shopify use {% paginate %} above) =====
  var loadMore = section.querySelector('[data-load-more]');
  var grid = section.querySelector('.dc-grid');
  if(loadMore && grid){
    var clicks = 0;
    loadMore.addEventListener('click', function(){
      clicks++;
      var existing = grid.querySelectorAll('.dc-product');
      // Clone existing products to simulate load more
      var clones = Array.from(existing).slice(0, 8).map(function(el){ return el.cloneNode(true); });
      clones.forEach(function(c){ grid.appendChild(c); });
      if(clicks >= 2){
        loadMore.textContent = 'No more pieces';
        loadMore.disabled = true;
        loadMore.style.opacity = '0.4';
        loadMore.style.cursor = 'not-allowed';
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demure-product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.querySelector('.demeure-product');
  if(!section) return;

  // ===== Gallery =====
  (function(){
    var track = section.querySelector('[data-gallery-track]');
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    var current = section.querySelector('[data-gallery-current]');
    var total = section.querySelector('[data-gallery-total]');
    if(!track) return;

    var slides = track.querySelectorAll('.dp-gallery-slide');
    if(total) total.textContent = String(slides.length).padStart(2,'0');

    function update(){
      var w = track.clientWidth;
      if(w === 0) return;
      var idx = Math.round(track.scrollLeft / w);
      if(current) current.textContent = String(Math.min(idx + 1, slides.length)).padStart(2,'0');
    }
    if(prev) prev.addEventListener('click', function(){
      track.scrollBy({left:-track.clientWidth, behavior:'smooth'});
    });
    if(next) next.addEventListener('click', function(){
      track.scrollBy({left:track.clientWidth, behavior:'smooth'});
    });
    track.addEventListener('scroll', function(){ requestAnimationFrame(update); });
    update();
  })();

  // ===== Benefit cycler =====
  (function(){
    var track = section.querySelector('[data-benefit-track]');
    var prev = section.querySelector('[data-benefit-prev]');
    var next = section.querySelector('[data-benefit-next]');
    if(!track) return;
    var benefits = track.querySelectorAll('.dp-benefit');
    var idx = 0;
    function show(i){
      benefits.forEach(function(b, j){ b.classList.toggle('dp-active', j === i); });
    }
    show(0);
    if(prev) prev.addEventListener('click', function(){
      idx = (idx - 1 + benefits.length) % benefits.length;
      show(idx);
    });
    if(next) next.addEventListener('click', function(){
      idx = (idx + 1) % benefits.length;
      show(idx);
    });
    // Auto-rotate
    setInterval(function(){
      idx = (idx + 1) % benefits.length;
      show(idx);
    }, 5000);
  })();

  // ===== Variant option selectors =====
  (function(){
    var form = section.querySelector('form.dp-form');
    if(!form) return;

    var idInput = form.querySelector('[data-variant-id-input]');
    var jsonScript = form.querySelector('[data-variant-json]');
    var addBtn = form.querySelector('[data-add-btn]');
    var optionGroups = form.querySelectorAll('.dp-option');

    // Parse variant data
    var variants = [];
    if(jsonScript){
      try { variants = JSON.parse(jsonScript.textContent); } catch(e) { variants = []; }
    }

    // Read currently-selected option values, in order
    function getSelectedOptions(){
      var selected = [];
      optionGroups.forEach(function(group){
        var active = group.querySelector('.dp-option-value.dp-active');
        selected.push(active ? active.getAttribute('data-option-value') : null);
      });
      return selected;
    }

    // Find a variant matching the currently-selected options
    function findMatchingVariant(selectedOptions){
      return variants.find(function(v){
        return selectedOptions.every(function(val, i){
          return val === null || v.options[i] === val;
        });
      });
    }

    // Update the hidden ID input + button label based on selection
    function updateSelection(){
      var selected = getSelectedOptions();
      var match = findMatchingVariant(selected);

      if(match){
        if(idInput) idInput.value = match.id;
        if(addBtn){
          if(match.available){
            addBtn.disabled = false;
            addBtn.style.opacity = '';
            addBtn.style.cursor = '';
            // Reset to default text (icon + label)
            addBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 8h12l-1 13H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg> ' + (addBtn.getAttribute('data-default-text') || 'Add to Cart');
          } else {
            addBtn.disabled = true;
            addBtn.style.opacity = '0.5';
            addBtn.style.cursor = 'not-allowed';
            addBtn.textContent = 'Sold Out';
          }
        }
      }

      // Mark unavailable values
      optionGroups.forEach(function(group, groupIdx){
        var values = group.querySelectorAll('.dp-option-value');
        values.forEach(function(btn){
          var testSelection = selected.slice();
          testSelection[groupIdx] = btn.getAttribute('data-option-value');
          var v = findMatchingVariant(testSelection);
          if(v && !v.available){
            btn.classList.add('dp-soldout');
          } else {
            btn.classList.remove('dp-soldout');
          }
        });
      });
    }

    // Stash default button text for re-use
    if(addBtn) addBtn.setAttribute('data-default-text', (addBtn.textContent || 'Add to Cart').trim());

    // Click handlers
    optionGroups.forEach(function(group){
      var values = group.querySelectorAll('.dp-option-value');
      values.forEach(function(v){
        v.addEventListener('click', function(){
          values.forEach(function(x){ x.classList.remove('dp-active'); });
          v.classList.add('dp-active');
          updateSelection();
        });
      });
    });

    // Initialize on load
    updateSelection();
  })();

  // ===== Related carousel =====
  (function(){
    var track = section.querySelector('[data-related-track]');
    var prev = section.querySelector('[data-related-prev]');
    var next = section.querySelector('[data-related-next]');
    if(!track) return;
    var items = track.querySelectorAll('.dp-related-card');
    function step(){
      var first = items[0];
      if(!first) return 0;
      return first.getBoundingClientRect().width + 32;
    }
    function update(){
      var maxScroll = track.scrollWidth - track.clientWidth;
      if(prev) prev.disabled = track.scrollLeft <= 2;
      if(next) next.disabled = track.scrollLeft >= maxScroll - 2;
    }
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
    track.addEventListener('scroll', function(){ requestAnimationFrame(update); });
    update();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
